module.exports = [{
      plugin: require('/codebuild/output/src636634666/src/node_modules/gatsby-plugin-rollbar/gatsby-browser.js'),
      options: {"plugins":[],"captureUncaught":true,"captureUnhandledRejections":true,"payload":{"environment":"production"}},
    },{
      plugin: require('/codebuild/output/src636634666/src/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
